export const founders = [
  {
    initials: "MS",
    name: "Maneesh Shah",
    photo: "/founders/maneesh.jpeg",
    role: "Co-Founder · Managed Services & Client Strategy",
    bio: "Maneesh leads UMI's managed services and client relationships — the person you'll speak to first, and the one who makes sure promises made are promises kept. He co-founded UMI to give Adelaide small businesses enterprise-calibre IT support without the jargon, the lock-ins, or the runaround.",
    testid: "founder-card-maneesh",
  },
  {
    initials: "UR",
    name: "Umair Rizvi",
    photo: "/founders/umair.jpeg",
    role: "Co-Founder · Software & Technical Delivery",
    bio: "Umair founded Astra Custom Software, an Adelaide development studio that has delivered 70+ projects over eight years for local, interstate and international clients. He leads UMI's custom software and integration work — turning clunky, manual processes into tools that fit how your business actually runs.",
    testid: "founder-card-umair",
  },
  {
    initials: "IP",
    name: "Indra Pradhan",
    photo: "/founders/indra.webp",
    role: "Co-Founder · Hardware & Support Operations",
    bio: "Indra owns and runs I Am Repairer, an Adelaide device-repair business known for same-day service and a wall of genuine five-star customer reviews. He brings that same hands-on, fix-it-properly ethos to UMI's support operations — workshop-grade hardware expertise included.",
    testid: "founder-card-indra",
  },
];
